/** @format */

import React from 'react';
import { TimePicker } from 'antd';
import './style.css';

export default function CustomTimePicker(props) {
	return <TimePicker {...props} />;
}
